﻿import { Mail } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function CheckEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? undefined;

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/40">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="space-y-4">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-7 w-7 text-primary" />
          </div>
          <div className="space-y-2">
            <CardTitle className="text-2xl">Emailini kontrol et</CardTitle>
            <CardDescription>
              {email ? (
                <>
                  <strong>{email}</strong> adresine doğrulama linki gönderdik. Hesabını
                  aktifleştirmek için linke tıkla.
                </>
              ) : (
                "Kaydolduğun email adresine doğrulama linki gönderdik."
              )}
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Email gelmediyse spam klasörünü kontrol et. Link 48 saat geçerlidir.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Giriş Sayfasına Dön</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
